import { useEffect, useState } from "react";
import SideBar from "../components/sideBar";
import translateText, {
  LanguageDirection,
  currentLanguage,
} from "../signals/language.signal";
import Accordion from "react-bootstrap/Accordion";
import {
  catalogNo,
  catalogSearchData,
  fetchCatalog,
  fetchSearchCatalog,
} from "../signals/catalogData.signal";
import CatalogBox from "../components/catalogBox";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import Form from "react-bootstrap/Form";
const Catalog = () => {
  const [activeEventKey, setActiveEventKey] = useState(null);
  const [searchActiveEventKey, setSearchActiveEventKey] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchCatalog();
        catalogNo.value = result;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  const [Search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  if (!Search) {
    catalogSearchData.value = null;
  }

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };
  const handleSubmit = async (event) => {
    setLoading(true);
    setDisabled(true);
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        const response = await fetchSearchCatalog(Search);

        if (response) {
          catalogSearchData.value = response;
        } else {
          console.error("Authentication failed");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
        setDisabled(false);
      }
    }
  };

  return (
    <div
      id="card"
      className="align-items-sm-center d-flex justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "Catalogs")}
      />
      <Form
        onSubmit={handleSubmit}
        className="align-items-sm-center d-flex justify-content-center w-100 p-3"
      >
        <div className="loginContaner bg-white p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
          <div className="mb-1  w-100 ">
            <div className="input-group">
              <input
                type="text"
                className="form-control rounded-3"
                id="searchCatalog"
                value={Search}
                placeholder={translateText(
                  currentLanguage.value,
                  "SearchCatalogTitle"
                )}
                onChange={handleSearchChange}
                required
              />
              <button
                type="submit"
                className="btn btn-primary border rounded-3"
                style={{ background: primary.value, color: primaryFount.value }}
                id="button-addon2"
                disabled={disabled}
              >
                {loading
                  ? translateText(currentLanguage.value, "Loading") + "..."
                  : translateText(currentLanguage.value, "Search")}
              </button>
            </div>
          </div>
          {catalogSearchData.value ? (
            <div className=" pt-3 align-items-sm-center loginContaner d-flex justify-content-center w-100 flex-md-row flex-wrap">
              <div className="row w-100 p-0">
                <Accordion
                  activeKey={searchActiveEventKey}
                  onSelect={setSearchActiveEventKey}
                  className=""
                >
                  {catalogSearchData.value.map((items, index) => (
                    <Accordion.Item
                      eventKey={index.toString()}
                      key={items.CATALOG_NO}
                    >
                      <Accordion.Header>
                        <h6
                          className={
                            LanguageDirection.value == "rtl"
                              ? "text-end m-0 w-100 "
                              : "text-start m-0 w-100 "
                          }
                        >
                          {translateText(currentLanguage.value, "CatalogNo")}{" "}
                          {items.CATALOG_NO}
                        </h6>
                      </Accordion.Header>
                      <Accordion.Body className="row">
                        {searchActiveEventKey === index.toString() && (
                          <CatalogBox catano={items.CATALOG_NO} />
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Form>
      {catalogNo.value ? (
        <div className="container pt-3 align-items-sm-center loginContaner d-flex justify-content-center w-100 flex-md-row flex-wrap">
          <div className="row w-100 p-0">
            <Accordion
              activeKey={activeEventKey}
              onSelect={setActiveEventKey}
              className=""
            >
              {catalogNo.value.map((items, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={items.CATALOG_NO}
                >
                  <Accordion.Header>
                    <h6
                      className={
                        LanguageDirection.value == "rtl"
                          ? "text-end m-0 w-100 "
                          : "text-start m-0 w-100 "
                      }
                    >
                      {translateText(currentLanguage.value, "CatalogNo")}{" "}
                      {items.CATALOG_NO}
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body className="row">
                    {activeEventKey === index.toString() && (
                      <CatalogBox catano={items.CATALOG_NO} />
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      ) : (
        <div
          className="d-flex justify-content-center flex-column align-items-center h-100 mt-5"
          style={{ color: primary.value }}
        >
          <div className="spinner-grow" role="status">
            <span className="visually-hidden ">
              {translateText(currentLanguage.value, "Loading")}
            </span>
          </div>
          <h6 className="mt-3">
            {translateText(currentLanguage.value, "Loading")}
          </h6>
        </div>
      )}
    </div>
  );
};

export default Catalog;
